function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "rewards/page-master-gold");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "0.00010546875 0 45 0 45 47.9999652 0.00010546875 47.9999652"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "path-3",
  points: "0.00010546875 0 45 0 45 44.5217043 0.00010546875 44.5217043"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "path-5",
  points: "0.00010546875 0 45 0 45 44.5217043 0.00010546875 44.5217043"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Product",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Dashboard-Rewards-1440",
  transform: "translate(-1006.000000, -585.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "rewards/page-master-gold",
  transform: "translate(1006.000000, 585.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-16"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.5001055,47.9999652 L22.5001055,47.9999652 C10.0734258,47.9999652 0.00010546875,38.0333565 0.00010546875,25.7390957 L0.00010546875,4.17387826 C0.00010546875,1.86883478 1.88869922,-3.47826087e-05 4.21885547,-3.47826087e-05 L40.7813555,-3.47826087e-05 C43.1111602,-3.47826087e-05 45.0001055,1.86883478 45.0001055,4.17387826 L45.0001055,25.7390957 C45.0001055,38.0333565 34.9264336,47.9999652 22.5001055,47.9999652",
  id: "Fill-1",
  fill: "#AD8D07",
  mask: "url(#mask-2)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-6"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-4",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-3"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.5001055,44.5217043 L22.5001055,44.5217043 C10.0734258,44.5217043 0.00010546875,34.5550957 0.00010546875,22.2608348 L0.00010546875,4.17387826 C0.00010546875,1.86883478 1.88869922,-3.47826087e-05 4.21885547,-3.47826087e-05 L40.7813555,-3.47826087e-05 C43.1111602,-3.47826087e-05 45.0001055,1.86883478 45.0001055,4.17387826 L45.0001055,22.2608348 C45.0001055,34.5550957 34.9264336,44.5217043 22.5001055,44.5217043",
  id: "Fill-4",
  fill: "#FFDC4A",
  mask: "url(#mask-4)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-9"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-6",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-5"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.7813555,-3.47826087e-05 L4.21885547,-3.47826087e-05 C1.88905078,-3.47826087e-05 0.00010546875,1.86883478 0.00010546875,4.17387826 L0.00010546875,22.2608348 C0.00010546875,34.5550957 10.0734258,44.5217043 22.5001055,44.5217043 L22.5001055,44.5217043 C34.9264336,44.5217043 45.0001055,34.5550957 45.0001055,22.2608348 L45.0001055,4.17387826 C45.0001055,1.86883478 43.1111602,-3.47826087e-05 40.7813555,-3.47826087e-05 M40.7813555,4.17387826 L40.7813555,22.2608348 C40.7813555,32.2340522 32.580457,40.3477913 22.5001055,40.3477913 C12.4197539,40.3477913 4.21885547,32.2340522 4.21885547,22.2608348 L4.21885547,4.17387826 L40.7813555,4.17387826",
  id: "Fill-7",
  fill: "#D3AB05",
  mask: "url(#mask-6)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M35.0107734,12.452487 L33.4449141,12.452487 L11.3379609,12.452487 L9.98936719,12.452487 C9.25003125,12.452487 8.65096875,13.0455304 8.65096875,13.7766609 L8.65096875,28.4904 C8.65096875,29.2215304 9.25003125,29.8145739 9.98936719,29.8145739 L19.5697969,29.8145739 C19.5697969,30.7891826 20.3685469,31.5794435 21.353625,31.5794435 L23.6465156,31.5794435 C24.6319453,31.5794435 25.4306953,30.7891826 25.4306953,29.8145739 L35.0107734,29.8145739 C35.7501094,29.8145739 36.3491719,29.2215304 36.3491719,28.4904 L36.3491719,13.7766609 C36.3491719,13.0455304 35.7501094,12.452487 35.0107734,12.452487",
  id: "Fill-10",
  fill: "#AD8D07"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.232043,27.409287 L25.4305195,27.409287 C24.0654023,27.409287 22.9175508,28.2778087 22.5923555,29.4538087 L22.4074336,29.4538087 C22.0825898,28.2778087 20.9354414,27.409287 19.5696211,27.409287 L11.7673945,27.409287 C11.3659102,27.409287 11.0393086,27.0868522 11.0393086,26.6889391 L11.0393086,10.2312 C11.0393086,9.83398261 11.3659102,9.51085217 11.7673945,9.51085217 L19.5696211,9.51085217 C21.1878633,9.51085217 22.4998945,10.7313739 22.4998945,12.2367652 C22.4998945,10.7313739 23.8115742,9.51085217 25.4305195,9.51085217 L33.232043,9.51085217 C33.6342305,9.51085217 33.9601289,9.83328696 33.9601289,10.2312 L33.9601289,26.6889391 C33.9601289,27.0868522 33.6342305,27.409287 33.232043,27.409287",
  id: "Fill-12",
  fill: "#F7EED2"
}), /*#__PURE__*/React.createElement("line", {
  x1: 22.4999297,
  y1: 12.0253565,
  x2: 22.4999297,
  y2: 28.7154435,
  id: "Stroke-14",
  stroke: "#F2E5C0",
  strokeWidth: 1.73913043,
  strokeLinecap: "round"
})))));

var SvgPageMasterGold = function SvgPageMasterGold(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "48px",
    viewBox: "0 0 45 48",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPageMasterGold, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/page-master-gold.0c7d0683.svg";
export { ForwardRef as ReactComponent };